import classNames from 'classnames';
import { isNil } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import Ref from '../../components/Ref/Ref';
import Position from '../../types/enum/Position';
import Popover from '../Popover/Popover';
import './Tooltip.scss';
import ITooltipProps from './TooltipProps';

const Tooltip = ({ className, children, label, labelNode, delay = 150, position = Position.BOTTOM }: ITooltipProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const trigger = useRef<HTMLElement>();
  const isHovering = useRef<boolean>(false);
  const timeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (trigger.current) {
      setMouseEnter(trigger.current);
      setMouseLeave(trigger.current);
    }

    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger]);

  function setMouseEnter(trig: HTMLElement) {
    trig.onmouseenter = () => {
      isHovering.current = true;
      timeout.current = setTimeout(() => {
        if (isHovering.current) {
          setIsOpen(true);
        }
      }, delay);
    };
  }

  function setMouseLeave(trig: HTMLElement) {
    trig.onmouseleave = () => {
      if (timeout.current) {
        clearTimeout(timeout.current);
      }
      isHovering.current = false;
      setIsOpen(false);
    };
  }

  function assignRef(element: HTMLElement) {
    trigger.current = element;
  }

  function getTrigger() {
    return trigger.current!;
  }

  const classes = classNames('tooltip', 'no-print', className);

  return (
    <>
      <Ref childRef={assignRef}>{children}</Ref>
      <Popover isOpen={isOpen} getTargetNode={getTrigger} transitionName="tooltip-anim" position={position} offset={10}>
        <div className={classes}>
          <div className="tooltip-message">{!isNil(labelNode) ? labelNode : label}</div>
        </div>
      </Popover>
    </>
  );
};

export default Tooltip;
